import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit() {}

  navigate(route: string) {
    this.router.navigate([route]);
  }
}
